import { render, staticRenderFns } from "./ThemeFooter.vue?vue&type=template&id=28c1a6c0&scoped=true&"
import script from "./ThemeFooter.vue?vue&type=script&lang=js&"
export * from "./ThemeFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c1a6c0",
  null
  
)

export default component.exports